// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidenav---sidenav---_2tBP {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1006;\n    min-width: 64px;\n    background: #4575B4;\n    -webkit-transition: min-width 0.15s;\n    -moz-transition: min-width 0.15s;\n    -o-transition: min-width 0.15s;\n    -ms-transition: min-width 0.15s;\n    transition: min-width 0.15s;\n    height: 200%;\n}", ""]);
// Exports
module.exports = exports;
